
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src994476363/src/vl-app/pages/clinician/index.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import dynamic from 'next/dynamic';
import { Row, Col } from 'antd';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import ClinicianCallTestSession from '@components/Clinicians/CallTestSession/ClinicianCallTestSession';
import Header from '@components/Layouts/Header/Header';

const NextAppointment = dynamic(() => import('@components/Card/NextAppointment/NextAppointment'));
const PREMScore = dynamic(() => import('@components/Card/PREMScore/PREMScore'));
const Calendar = dynamic(() => import('@components/Calendar/Calendar'));

const Clinician = () => {
  const { t } = useTranslation('common');
  const initialised = useInitialisedStore();
  const displayTestCallWindow = new URLSearchParams(window.location.search).has('clinicianTestCall');

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  if (displayTestCallWindow) {
    return (
      <>
        <Header pageType="clinician" pageTitle="Clinician" />
        <ClinicianCallTestSession />
      </>
    );
  }

  const desktopMediaQuery = window.matchMedia('(min-width: 1200px) and (min-height: 840px)');

  // Fixes page getting stuck when scaling up the window after scrolling down
  function resetScrollOnResize(e: MediaQueryListEvent): void {
    if (e.matches) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });

      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }

  desktopMediaQuery.addEventListener('change', resetScrollOnResize);
  resetScrollOnResize(desktopMediaQuery as unknown as MediaQueryListEvent);

  return (
    <>
      <Header pageType="clinician" pageTitle="Clinician" />
      <section className="section-layout dashboard-viewport-wrapper">
        <main className="container" id="page-content">
          <Row gutter={[20, 30]}>
            <Col
              xxl={{ span: 4 }}
              xl={{ span: 5 }}
              lg={{ span: 6 }}
              md={{ span: 8 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <NextAppointment className="mB20" />
              <PREMScore />
            </Col>
            <Col
              xxl={{ span: 20 }}
              xl={{ span: 19 }}
              lg={{ span: 18 }}
              md={{ span: 16 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Calendar />
            </Col>
          </Row>
        </main>
      </section>
    </>
  );
};

export default Clinician;
export const Route = createFileRoute('/clinician/')({ component: Clinician });
